import './wdyr';

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { store, persistor } from './core/store/store';
import FontStyles from './core/theme/globals';

const queryClient = new QueryClient();
const ProviderComponent = () => (
	<Provider store={store}>
		<PersistGate persistor={persistor} loading={null}>
			<App className={FontStyles} />
		</PersistGate>
	</Provider>
);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
  <React.Fragment>
    <Router>
      <QueryClientProvider client={queryClient}>
        <ProviderComponent />
        {process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'development' ||
          process.env.NODE_ENV !== 'qa' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </Router>
  </React.Fragment>
);
